// Le scelte fatte sul sito (gli sport insegnati, maestro o circolo) passano
// alla registrazione, così l'app nasce già pronta: il questionario parte
// dal ruolo giusto e il maestro insegna gli sport che ha scelto. Stanno
// nella sessione del browser, non sul server: sono un suggerimento, e il
// questionario le fa comunque confermare.

const KEY = "incampo.landingChoice"

export const saveLandingChoice = choice => {
	try {
		window.sessionStorage.setItem(KEY, JSON.stringify(choice))
	} catch {
		// navigazione privata: il questionario parte dai suoi valori di sempre
	}
}

export const readLandingChoice = () => {
	try {
		const saved = JSON.parse(window.sessionStorage.getItem(KEY) ?? "null")
		if (!saved || !Array.isArray(saved.sports)) return null
		return { sports: saved.sports, role: saved.role === "circolo" ? "circolo" : "maestro" }
	} catch {
		return null
	}
}
